/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";

/**
 *
 * @export
 * @interface CustomerSpecificPricingResponse
 */
export interface CustomerSpecificPricingResponse {
  /**
   *
   * @type {Array<CustomerSpecificPricingAgreement>}
   * @memberof CustomerSpecificPricingResponse
   */
  agreements: Array<CustomerSpecificPricingAgreement>;
}

/**
 * Check if a given object implements the CustomerSpecificPricingResponse interface.
 */
export function instanceOfCustomerSpecificPricingResponse(
  value: object,
): value is CustomerSpecificPricingResponse {
  if (!("agreements" in value) || value["agreements"] === undefined)
    return false;
  return true;
}

export function CustomerSpecificPricingResponseFromJSON(
  json: any,
): CustomerSpecificPricingResponse {
  return CustomerSpecificPricingResponseFromJSONTyped(json, false);
}

export function CustomerSpecificPricingResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingResponse {
  if (json == null) {
    return json;
  }
  return {
    agreements: (json["agreements"] as Array<any>).map(
      CustomerSpecificPricingAgreementFromJSON,
    ),
  };
}

export function CustomerSpecificPricingResponseToJSON(
  json: any,
): CustomerSpecificPricingResponse {
  return CustomerSpecificPricingResponseToJSONTyped(json, false);
}

export function CustomerSpecificPricingResponseToJSONTyped(
  value?: CustomerSpecificPricingResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreements: (value["agreements"] as Array<any>).map(
      CustomerSpecificPricingAgreementToJSON,
    ),
  };
}
